/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_QueuesInputs */

const en_svchip_queues = /** @type {(inputs: Svchip_QueuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Queues`)
};

const ar_svchip_queues = /** @type {(inputs: Svchip_QueuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قوائم الانتظار`)
};

const bn_svchip_queues = /** @type {(inputs: Svchip_QueuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কিউ`)
};

const de_svchip_queues = /** @type {(inputs: Svchip_QueuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warteschlangen`)
};

const es_svchip_queues = /** @type {(inputs: Svchip_QueuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colas`)
};

const fr_svchip_queues = /** @type {(inputs: Svchip_QueuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Files d'attente`)
};

const pt_svchip_queues = /** @type {(inputs: Svchip_QueuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filas`)
};

const zh_svchip_queues = /** @type {(inputs: Svchip_QueuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`队列`)
};

const tr_svchip_queues = /** @type {(inputs: Svchip_QueuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Queues`)
};

const ru_svchip_queues = /** @type {(inputs: Svchip_QueuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очереди`)
};

const pl_svchip_queues = /** @type {(inputs: Svchip_QueuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kolejki`)
};

/**
* | output |
* | --- |
* | "Queues" |
*
* @param {Svchip_QueuesInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_queues = /** @type {((inputs?: Svchip_QueuesInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_QueuesInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_queues(inputs)
	if (locale === "bn") return bn_svchip_queues(inputs)
	if (locale === "de") return de_svchip_queues(inputs)
	if (locale === "es") return es_svchip_queues(inputs)
	if (locale === "fr") return fr_svchip_queues(inputs)
	if (locale === "pt") return pt_svchip_queues(inputs)
	if (locale === "zh") return zh_svchip_queues(inputs)
	if (locale === "tr") return tr_svchip_queues(inputs)
	if (locale === "ru") return ru_svchip_queues(inputs)
	if (locale === "pl") return pl_svchip_queues(inputs)
	return en_svchip_queues(inputs)
});